import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Wrapper = styled(Box)(({ theme }) => ({
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  paddingBottom: theme.spacing(3),
  margin: theme.spacing(3, 0, 2),
  fontFamily: theme.typography.fontFamily,

  "& svg": {
    overflow: "visible",
  },
}));
